import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

export function Skeleton(skeletonProps: ComponentProps<'div'>) {
  const { className, ...props } = skeletonProps;
  return <div data-slot="skeleton" className={cn('bg-muted/50 animate-pulse rounded-sm', className)} {...props} />;
}
